
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

define('component!NotificationHeaderDropdownComponent',['require','react','react-dom','underscore','jquery','lib/Podio.Push','lib/Podio.UI.Header.Counters','lib/Podio.UI.DynamicContent','lib/Podio.Utils','moment','lib/Podio.Utils','lib/Podio.Colors','lib/podio-ui-kit'],function (require) {
  'use strict';

  var React = require('react');
  var ReactDOM = require('react-dom');
  var _ = require('underscore');
  var $ = require('jquery');
  var push = require('lib/Podio.Push');
  var HeaderCounters = require('lib/Podio.UI.Header.Counters');
  var DynamicContentManager = require('lib/Podio.UI.DynamicContent');
  var utils = require('lib/Podio.Utils');
  var moment = require('moment');
  var podioUtils = require('lib/Podio.Utils');
  var PodioColors = require('lib/Podio.Colors');

  var _require = require('lib/podio-ui-kit');

  var Notifications = _require.Notifications;
  var Icon = _require.Icon;
  var Preloader = _require.Preloader;
  var getConst = _require.getConst;
  var provide = _require.provide;
  var propTypes = _require.propTypes;
  var _require$utils = _require.utils;
  var color = _require$utils.color;
  var Radium = _require$utils.Radium;

  var MAX_HEIGHT = 600;
  var OFFSET_TOP = 41;
  var GUTTER_BOTTOM = 50;

  var NotificationHeaderDropdownComponent = (function (_React$Component) {
    _inherits(NotificationHeaderDropdownComponent, _React$Component);

    function NotificationHeaderDropdownComponent(props) {
      _classCallCheck(this, NotificationHeaderDropdownComponent);

      _get(Object.getPrototypeOf(NotificationHeaderDropdownComponent.prototype), 'constructor', this).call(this, props);
      this.state = {
        show: undefined,
        inboxSelected: false
      };
    }

    _createClass(NotificationHeaderDropdownComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this = this;

        // Subscribe to push service
        push.on('user', 'notification_unread', function (_ref) {
          var count = _ref.count;

          _this.props.setNotificationUnreadCount(count);
        });

        push.on('user', 'notification_create', function () {
          // If the dropdown is open, we update the data when we receive a new notification
          if (_this.state.show) {
            _this.performNotificationReconciliation();
          }
        });

        // Initial fetch of the unread count
        this.props.fetchNotificationUnreadCount();

        // Adjust height to prevent overflow on small windows
        $(window).on('resize', _.throttle(function (e) {
          return _this.adjustMaxHeight();
        }, 100));
        this.adjustMaxHeight();
        ReactDOM.findDOMNode(this).parentNode.className.includes('selected') ? this.setState({ inboxSelected: true }) : this.setState({ inboxSelected: false });

        // Close the dropdown whenever the user clicks outside of it
        $(ReactDOM.findDOMNode(this)).on('outsideclick', function () {
          if (_this.state.show) {
            _this.setState({ show: false });
          }
        });

        // Whenever the user activates this window/tab, there's a chance that notifications were changed somewhere else.
        // Therefore, if the dropdown is opened, we reconcile the data.
        // In any case, we fetch the unread count in case the push service missed it.
        $(window).on('focus', function () {
          if (_this.state.show) {
            _this.performNotificationReconciliation();
          }
        });

        // Enable toggling via 'n' hotkey
        $(document).bind('keydown', 'n', function (e) {
          return _this.toggleNotificationPanel();
        });

        // Prevent the rest of the page to scroll in the background when scrolling the notification dropdown
        // Note: Ignore IE 11 since it does not handle overflow correctly and is a hassle to make this work on.
        if (!/Trident.*rv[ :]*11./.test(navigator.userAgent)) {
          $('body').on('wheel', function (e) {
            var listElement = $(e.target).parents('.PodioUI__Notifications__list')[0];

            if (!listElement) {
              return;
            }

            var isAtTopScrollLimit = listElement.scrollTop === 0 && e.originalEvent.deltaY < 0;
            var isAtBottomScrollLimit = listElement.scrollHeight === listElement.scrollTop + listElement.clientHeight && e.originalEvent.deltaY > 0;

            if (isAtTopScrollLimit || isAtBottomScrollLimit) {
              e.stopPropagation();
              e.preventDefault();
            }
          });
        }
      }
    }, {
      key: 'UNSAFE_componentWillReceiveProps',
      value: function UNSAFE_componentWillReceiveProps(_ref2) {
        var _ref2$notifications = _ref2.notifications;
        var nextViewFilter = _ref2$notifications.viewFilter;
        var nextUnread = _ref2$notifications.unread;
        var _props$notifications = this.props.notifications;
        var currentViewFilter = _props$notifications.viewFilter;
        var currentUnread = _props$notifications.unread;

        // Set the <title> tag value when unread count changes
        if (currentUnread !== nextUnread) {
          HeaderCounters.updateNotificationsCount(nextUnread);
        }
      }
    }, {
      key: 'UNSAFE_componentWillUpdate',
      value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
        var _this2 = this;

        // Reconcile notifications when state.show toggles to 'true' (and was 'false' before)
        if (nextState.show && nextState.show !== this.state.show) {
          // If this is the first time the user opens the dropdown (`show` being `undefined`),
          // then we fetch the viewFilter User Property to get the last remembered viewFilter.
          if (this.state.show === undefined) {
            this.props.fetchNotificationsViewFilter().then(function (viewFilter) {
              _this2.performNotificationReconciliation();
            });
          } else {
            this.performNotificationReconciliation();
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var unread = this.props.notifications.unread;
        var primaryColorDark = PodioColors.block.teal900Opaque;
        var primaryColorDarkest = color(getConst('color_PRIMARY')).darken(0.3).hexString();
        var isActive = Radium.getState(this.state, 'trigger', ':hover') || Radium.getState(this.state, 'trigger', ':focus') || this.state.show;

        var ownStyles = {
          height: '100%',
          ':hover': {}
        };

        var triggerStyles = {
          height: '100%',
          display: 'flex',
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          minWidth: '48px',
          lineHeight: '16px',
          cursor: 'pointer',
          background: isActive ? primaryColorDark : undefined,
          borderRadius: '20px',
          ':hover': {
            background: this.state.inboxSelected ? undefined : primaryColorDark
          },
          ':focus': {
            outline: 'none 0',
            background: this.state.inboxSelected ? undefined : primaryColorDark
          }
        };

        var notificationsStyles = {
          base: {
            width: 550,
            maxHeight: this.state.maxHeight + 'px',
            position: 'absolute',
            right: '0px',
            top: '42px',
            boxShadow: '#ddd 0px 1px 1px'
          },
          notificationGroup: {
            avatar: {
              borderRadius: '50%'
            }
          }
        };

        var iconStyles = {
          svg: {
            display: 'inline-flex'
          },
          label: {
            fontSize: '1.4rem',
            color: PodioColors.block.teal900,
            fontWeight: 'bold',
            marginLeft: '6px'
          }
        };

        var trigger = !this.state.show && this.state.isNavigatingPage ? React.createElement(
          'div',
          { style: triggerStyles },
          React.createElement(Preloader, { color: PodioColors.block.teal900, size: 13, style: { display: 'flex', alignItems: 'center' },
            onClick: function (e) {
              return _this3.toggleNotificationPanel(e);
            } })
        ) : React.createElement(
          'div',
          { key: 'trigger', tabIndex: 0, style: triggerStyles, onClick: function (e) {
              return _this3.toggleNotificationPanel(e);
            },
            onKeyUp: function (e) {
              return _this3.toggleNotificationPanel(e);
            } },
          unread ? React.createElement(
            'div',
            { style: iconStyles.svg },
            React.createElement('div', { className: 'icon-16 icon-notifications-with-count' }),
            React.createElement(
              'div',
              { style: iconStyles.label },
              unread
            )
          ) : React.createElement('div', { className: 'icon-16 icon-notifications' })
        );

        var notifications = this.state.show ? React.createElement(Notifications, { styles: notificationsStyles, onClickNotificationGroup: function (e, context) {
            return _this3.handleClickNotificationGroup(e, context);
          } }) : null;

        return React.createElement(
          'div',
          { key: 'wrapper', style: ownStyles },
          trigger,
          notifications
        );
      }

      /**
       * Finds the date of oldest notification group in our current store and passes that to the reconciliation action,
       * in order to find out what changed in that data, since it was fetched.
       */
    }, {
      key: 'performNotificationReconciliation',
      value: function performNotificationReconciliation() {
        var _props$notifications2 = this.props.notifications;
        var groups = _props$notifications2.groups;
        var viewFilter = _props$notifications2.viewFilter;
        var viewSize = _props$notifications2.viewSize;

        var groupIds = Object.keys(groups);

        if (groupIds.length > 0) {
          var oldestGroupTimestamp = groupIds.reduce(function (prev, id) {
            return groups[id].order < prev ? groups[id].order : prev;
          }, Infinity);

          this.props.reconcileNotifications(moment(oldestGroupTimestamp).format('YYYY-MM-DD HH:mm:ss'));
        } else {
          this.props.fetchNotificationGroups(viewFilter, viewSize, 0);
        }
      }
    }, {
      key: 'adjustMaxHeight',
      value: function adjustMaxHeight() {
        if (window.innerHeight > MAX_HEIGHT + OFFSET_TOP + GUTTER_BOTTOM) {
          this.setState({ maxHeight: MAX_HEIGHT });
        } else {
          this.setState({ maxHeight: window.innerHeight - OFFSET_TOP - GUTTER_BOTTOM });
        }
      }
    }, {
      key: 'toggleNotificationPanel',
      value: function toggleNotificationPanel(e) {
        if (e && e.type === 'keyup' && e.keyCode !== 13) {
          return;
        }

        this.setState({ show: !this.state.show });
      }
    }, {
      key: 'handleClickNotificationGroup',
      value: function handleClickNotificationGroup(e, _ref3) {
        var _this4 = this;

        var _ref3$ref = _ref3.ref;
        var type = _ref3$ref.type;
        var id = _ref3$ref.id;
        var url = _ref3.link;

        // If user wants to open in a new tab or window, we do nothing and let the browser proceed
        if (utils.isMetaEvent(e)) {
          return false;
        }

        // Hide the panel upon clicking a notification group
        this.toggleNotificationPanel();

        // Prevent navigation as the rest will be handled manually
        e.preventDefault();
        e.stopPropagation();

        if (DynamicContentManager.resolveNavigation(e, url)) {
          // If we should redirect to another page, we mark the notification as read first,
          // and then perform the redirect (ignoring any error, since navigation should be prioritised).
          this.setState({ isNavigatingPage: true });
          this.props.markNotificationAsReadByRef(type, id).then(function () {
            return window.open(url, '_self');
          })['catch'](function () {
            return window.open(url, '_self');
          });
        } else {
          // If we're **not** redirecting to a different page, we simply mark the notification as read
          // and let the DynamicContentManager handle the rest (in the .resolveNavigation() call).
          this.props.markNotificationAsReadByRef(type, id).then(function () {
            return _this4.props.fetchNotificationUnreadCount();
          });
        }
      }
    }]);

    return NotificationHeaderDropdownComponent;
  })(React.Component);

  NotificationHeaderDropdownComponent.propTypes = {
    fetchNotificationsViewFilter: propTypes.get('fetchNotificationsViewFilter'),
    fetchNotificationGroups: propTypes.get('fetchNotificationGroups'),
    reconcileNotifications: propTypes.get('reconcileNotifications'),
    fetchNotificationUnreadCount: propTypes.get('fetchNotificationUnreadCount'),
    setNotificationUnreadCount: propTypes.get('setNotificationUnreadCount'),
    setNotificationsViewFilter: propTypes.get('setNotificationsViewFilter'),
    markNotificationAsReadByRef: propTypes.get('markNotificationAsReadByRef'),
    notifications: propTypes.get('notifications')
  };

  NotificationHeaderDropdownComponent.defaultProps = {};

  return provide(NotificationHeaderDropdownComponent);
});
